import "./styles.css";

import { createRoot } from "react-dom/client";

import { withFeatureFlags } from "@smart/bridge-feature-flags-dom";
import { initMetrics } from "@smart/bridge-metrics-dom";
import { ManageApp } from "@smart/manage-components-dom";

initMetrics();

const App = withFeatureFlags(ManageApp);
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
